import authService from "@/services/auth/auth.service";

class GuardService {
	canAccess(to) {
		if (to.meta.requiresAuth) {
			const accessToken = authService.getAccessToken();
			if (!accessToken) {
				return false;
			}
		}
		return true;
	}

	decodeToken(token) {
		let base64Url = token.split(".")[1];
		let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
		let jsonPayload = decodeURIComponent(
			window
				.atob(base64)
				.split("")
				.map(function (c) {
					return (
						"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
					);
				})
				.join(""),
		);

		return JSON.parse(jsonPayload);
	}

	isTokenExpired(token) {
		const payload = this.decodeToken(token);
		const now = Math.floor(Date.now() / 1000);
		return payload.exp < now;
	}
}

const guardService = new GuardService();
export default guardService;
